import { createRoot } from 'react-dom/client'

import { loadPolyfills } from '@dhl/barcode-scanner-input'

import { App } from './App.js'
import './csp.js'
import './i18n.js'
import './setLocationHref.js'
import { getConfig } from './config/index.js'

const { cspNonce } = getConfig()

// @ts-expect-error
// eslint-disable-next-line camelcase
__webpack_nonce__ = cspNonce

loadPolyfills().then(() => {
  const container = document.getElementById('root')
  if (container) {
    const root = createRoot(container)
    root.render(<App />)
  }
})
